import React, { useEffect, useState } from 'react';
import { epochToDateString } from '../../../../helper';
import { getGuestAuthors } from '../../../../services/storyService';
import { uploadFileToS3 } from '../../../../services/uploadService';

const POST_AS_OPTIONS = [
  { value: 'briefing', title: 'Briefing' },
  { value: 'column', title: 'Column' },
];

const STORY_TYPE = {
  public: 'public',
  subscriberOnly: 'subscriberOnly',
};

// Author dropdown sentinels; guest registry ids are slugs so they can't clash.
const AUTHOR_SELF = '__self__';
const AUTHOR_NEW = '__new__';

function CreateSroryPopup({
  closePopupClick,
  submitBtnClick,
  allBriefings,
  heading,
  subHeading,
  canSetGuestAuthor = false,
}) {
  const [postAs, setPostAs] = useState('briefing');
  const [storyType, setStoryType] = useState(STORY_TYPE.subscriberOnly);
  const [selectedBriefing, setSelectedBriefing] = useState(allBriefings[0]);
  const [topics, setTopics] = useState('');

  // Guest byline (columns only): publish under a guest's name and photo
  // instead of the logged-in user's.
  const [guestAuthors, setGuestAuthors] = useState([]);
  const [authorChoice, setAuthorChoice] = useState(AUTHOR_SELF);
  const [guestName, setGuestName] = useState('');
  const [guestImageUrl, setGuestImageUrl] = useState('');
  const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

  useEffect(() => {
    if (canSetGuestAuthor) {
      getGuestAuthors().then(setGuestAuthors);
    }
  }, [canSetGuestAuthor]);

  const onAuthorChoiceChange = (e) => {
    const value = e.target.value;
    setAuthorChoice(value);
    const existing = guestAuthors.find((author) => author.id === value);
    setGuestName(existing ? existing.name : '');
    setGuestImageUrl(existing ? existing.imageUrl || '' : '');
  };

  const onGuestPhotoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setIsUploadingPhoto(true);
      const publicUrl = await uploadFileToS3(file, 'author-images');
      setGuestImageUrl(publicUrl);
    } catch (error) {
      console.error('Author photo upload failed', error);
      alert('Author photo upload failed. Please try again.');
    } finally {
      setIsUploadingPhoto(false);
    }
  };

  const showGuestSection = canSetGuestAuthor && postAs === 'column';
  const guestAuthor =
    showGuestSection && authorChoice !== AUTHOR_SELF && guestName.trim()
      ? { name: guestName.trim(), imageUrl: guestImageUrl }
      : null;

  const onValueChangePostAs = (e) => {
    if (e.target.value === 'column') {
      setSelectedBriefing(null);
    } else {
      setSelectedBriefing(allBriefings[0]);
    }
    setPostAs(e.target.value);
  };

  const onValueChangeBriefing = (e) => {
    const briefing = allBriefings.find((item) => item.id === e.target.value);
    setSelectedBriefing(briefing);
  };

  const onValueChangeSubcriberOnly = (e) => {
    setStoryType(
      e.target.checked ? STORY_TYPE.public : STORY_TYPE.subscriberOnly
    );
  };

  const onTopicsChange = (e) => {
    setTopics(e.target.value);
  };

  return (
    <div className='modal-overlay-write-story'>
      <div className='modal-content-create-story'>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h2
            style={{
              fontSize: '24px',
              fontWeight: '700',
              fontFamily: 'Nunito Sans',
            }}
          >
            Story Preview
          </h2>
          <span
            onClick={closePopupClick}
            style={{ cursor: 'pointer', fontSize: '24px' }}
          >
            &times;
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: 'solid',
            borderColor: 'grey',
            paddingBottom: '5px',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#949494',
              fontWeight: '400',
              fontFamily: 'Nunito Sans',
              marginBottom: '5px',
            }}
          >
            Send this as
          </p>
          <select
            name='send_as'
            id='send_as'
            style={{
              border: 'none',
              width: '100%',
              fontFamily: 'Nunito Sans',
              fontSize: '16px',
              fontWeight: '700',
              lineHeight: '27.28px',
            }}
            onChange={onValueChangePostAs}
          >
            {POST_AS_OPTIONS.map((item) => {
              return <option value={item.value}>{item.title}</option>;
            })}
          </select>
        </div>

        {postAs !== 'column' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              borderBottom: 'solid',
              borderColor: 'grey',
              paddingBottom: '5px',
            }}
          >
            <p
              style={{
                fontSize: '16px',
                color: '#949494',
                fontWeight: '400',
                fontFamily: 'Nunito Sans',
                marginBottom: '5px',
              }}
            >
              Select Briefing to post in
            </p>
            <select
              name='send_as'
              id='send_as'
              style={{
                border: 'none',
                width: '100%',
                fontFamily: 'Nunito Sans',
                fontSize: '16px',
                fontWeight: '700',
                lineHeight: '27.28px',
              }}
              onChange={onValueChangeBriefing}
            >
              {allBriefings.map((item) => {
                return <option value={item.id}>{item.title}</option>;
              })}
            </select>
          </div>
        )}

        {showGuestSection && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              borderBottom: 'solid',
              borderColor: 'grey',
              paddingBottom: '5px',
            }}
          >
            <p
              style={{
                fontSize: '16px',
                color: '#949494',
                fontWeight: '400',
                fontFamily: 'Nunito Sans',
                marginBottom: '5px',
              }}
            >
              Author (leave as yourself unless this is a guest column)
            </p>
            <select
              name='guest_author'
              id='guest_author'
              value={authorChoice}
              style={{
                border: 'none',
                width: '100%',
                fontFamily: 'Nunito Sans',
                fontSize: '16px',
                fontWeight: '700',
                lineHeight: '27.28px',
              }}
              onChange={onAuthorChoiceChange}
            >
              <option value={AUTHOR_SELF}>Myself</option>
              {guestAuthors.map((author) => (
                <option key={author.id} value={author.id}>
                  {author.name}
                </option>
              ))}
              <option value={AUTHOR_NEW}>New guest author…</option>
            </select>

            {authorChoice !== AUTHOR_SELF && (
              <div style={{ width: '100%', marginTop: '8px' }}>
                {authorChoice === AUTHOR_NEW && (
                  <input
                    type='text'
                    placeholder="Guest author's name"
                    value={guestName}
                    onChange={(e) => setGuestName(e.target.value)}
                    style={{
                      border: '1px solid #B7B7B7',
                      borderRadius: '4px',
                      width: '100%',
                      fontFamily: 'Nunito Sans',
                      fontSize: '16px',
                      padding: '4px 8px',
                      boxSizing: 'border-box',
                      marginBottom: '8px',
                    }}
                  />
                )}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  {guestImageUrl && (
                    <img
                      src={guestImageUrl}
                      alt='Guest author'
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                  <button
                    type='button'
                    disabled={isUploadingPhoto}
                    onClick={() =>
                      document.getElementById('guestAuthorPhotoUpload')?.click()
                    }
                    style={{
                      borderRadius: 100,
                      border: '1px solid #B7B7B7',
                      color: '#949494',
                      fontSize: 12,
                      padding: '6px 12px',
                      background: 'white',
                      cursor: 'pointer',
                    }}
                  >
                    {isUploadingPhoto
                      ? 'Uploading…'
                      : guestImageUrl
                      ? 'Replace photo'
                      : 'Upload photo'}
                  </button>
                  <input
                    id='guestAuthorPhotoUpload'
                    type='file'
                    accept='image/*'
                    style={{ display: 'none' }}
                    onChange={onGuestPhotoChange}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: 'solid',
            borderColor: 'grey',
            paddingBottom: '5px',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#949494',
              fontWeight: '400',
              fontFamily: 'Nunito Sans',
              marginBottom: '0px',
              paddingLeft: '0px',
            }}
          >
            Title
          </p>
          <input
            type='text'
            disabled
            value={heading || ''}
            style={{
              border: 'none',
              width: '100%',
              fontFamily: 'Nunito Sans',
              fontSize: '16px',
              fontWeight: '700',
              lineHeight: '27.28px',
              padding: '0px',
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: 'solid',
            borderColor: 'grey',
            paddingBottom: '5px',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#949494',
              fontWeight: '400',
              fontFamily: 'Nunito Sans',
              marginBottom: '5px',
            }}
          >
            Subtitle
          </p>
          <input
            type='text'
            value={subHeading || ''}
            disabled
            style={{
              border: 'none',
              width: '100%',
              fontSize: '16px',
              color: '#161616',
              fontWeight: '400',
              fontFamily: 'Nunito Sans',
              padding: '0px',
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: 'solid',
            borderColor: 'grey',
            paddingBottom: '5px',
          }}
        >
          <p
            style={{
              color: '#949494',
              fontWeight: '600',
              fontFamily: 'Nunito Sans',
              fontSize: '16px',
              marginBottom: '5px',
              padding: '0px',
            }}
          >
            Add or change topics (up to 5) so readers know about story
          </p>
          <input
            className='tag-input'
            type='text'
            placeholder='Add Topic'
            onChange={onTopicsChange}
            style={{
              border: 'none',
              width: '100%',
              fontSize: '15px',
              color: ' #949494',
              fontWeight: '400',
              padding: '0px',
              marginTop: '5px',
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <input type='checkbox' onChange={onValueChangeSubcriberOnly} />
          <p
            style={{
              fontSize: '15px',
              color: ' #949494',
              fontWeight: '400',
              marginLeft: '2px',
            }}
          >
            Public Story
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            marginTop: '10px',
          }}
        >
          <button
            style={{
              padding: '8px 16px',
              background: '#0B335E',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (
                showGuestSection &&
                authorChoice === AUTHOR_NEW &&
                !guestName.trim()
              ) {
                alert("Please enter the guest author's name.");
                return;
              }
              if (isUploadingPhoto) {
                alert('Please wait for the author photo to finish uploading.');
                return;
              }
              submitBtnClick(
                storyType,
                postAs,
                topics.split(' '),
                selectedBriefing,
                guestAuthor
              );
            }}
          >
            Submit for Review
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateSroryPopup;
